export default __webpack_public_path__ + "static/media/banner-ouvidoria.c5ce6966.png";